export { Tip } from './tip';
export type { TipProps } from './tip.types';
